import React from 'react';
import { withFullHydrate } from '@ecommerce/nest-ssr/common';
import StaticPageLayoutDesktop from 'layouts/static-page-layout/static-page-layout.desktop';
import InformationObligationBase from 'modules/static-pages/information-obligation-page/pages/information-obligation-page.base';

const InformationObligationDesktop: React.FC = () => (
    <StaticPageLayoutDesktop>
        <InformationObligationBase />
    </StaticPageLayoutDesktop>
);

export default withFullHydrate(InformationObligationDesktop, { root: '#root' }, 'modules/static-pages/information-obligation-page/pages/information-obligation-page.desktop');
